import { render, staticRenderFns } from "./preview-value.vue?vue&type=template&id=35b0e0e9&scoped=true&"
import script from "./preview-value.vue?vue&type=script&lang=js&"
export * from "./preview-value.vue?vue&type=script&lang=js&"
import style0 from "./preview-value.vue?vue&type=style&index=0&id=35b0e0e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0e0e9",
  null
  
)

export default component.exports